// Components==============
import { animate, motion, useMotionValue, useTransform } from 'framer-motion';
import { useMeasure } from 'hooks/useMeasure';
import React, { useContext, useEffect, useRef } from 'react';
import { GlobalRootPersonContext } from 'utilities/GlobalContext/GlobalRootPerson';
import { GlobalRootSkillContext } from 'utilities/GlobalContext/GlobalRootSkill';
import ReflectionIcon from '../ReflectionIcon/ReflectionIcon';
import './CircleRadius.module.scss';
// =========================

export default function Item({
  skill,
  person,
  size,
  initial,
  ring,
}: {
  skill?: { skill: SkillEntity; size: 'small' | 'big' };
  person?: PeopleEntity;
  size: number;
  initial: number;
  ring?: 'inner' | 'outer';
}) {
  const ref = useRef<HTMLImageElement>(null);
  const { height, width } = useMeasure(ref);

  const { setRootSkillModal } = useContext(GlobalRootSkillContext);
  const { setRootPersonModal } = useContext(GlobalRootPersonContext);

  const trackRadius = size / 2;

  // top: 1.5; right: 0; bottom: 0.5; left: 1;
  const initialAngle = Math.PI * initial;
  const angle = useMotionValue(initialAngle);

  const x = useTransform(
    angle,
    (a) => Math.cos(a) * (trackRadius - width / 16)
  );
  const y = useTransform(
    angle,
    (a) => Math.sin(a) * (trackRadius - height / 16)
  );

  useEffect(() => {
    const controls = animate(
      angle,
      Math.PI *
        (initial + (Math.random() - 0.5) * (ring === 'inner' ? 0.2 : 0.06)),
      {
        type: 'tween',
        duration: 10,
        repeat: Infinity,
        repeatType: 'reverse',
        delay: Math.random() * 4,
        repeatDelay: Math.random() * 0.5,
      }
    );
    return controls.stop;
  }, []);

  return (
    <motion.div
      styleName="item"
      style={{
        x,
        y,
        width,
        height,
        left: trackRadius - width / 2,
        top: trackRadius - height / 2,
      }}
    >
      {skill ? (
        <ReflectionIcon
          name={skill.skill.name}
          image={`/storage/${skill.skill.icon}`}
          type={skill.size === 'big' ? 'big skill' : 'small skill'}
          reference={ref}
          onClick={() => setRootSkillModal(skill.skill)}
        />
      ) : person ? (
        <ReflectionIcon
          name={person.name}
          image={`/storage/${person.image}`}
          reference={ref}
          onClick={() => setRootPersonModal(person)}
        />
      ) : (
        <></>
      )}
    </motion.div>
  );
}
